import { StateCreator } from 'zustand';
import { IAppState, IRecentlyViewedVehiclesSlice } from './stateTypes';
import HomePageExperience from '../../pages/home/hero/store/HomePageExperience';
import { getVehiclesForRecentlyViewedTiles } from '../../pages/home/hero/utils';

const createRecentlyViewedVehiclesSlice: StateCreator<IAppState, [], [], IRecentlyViewedVehiclesSlice> = (
    set,
    get,
) => ({
    recentlyViewedVehicles: [],
    setRecentlyViewedVehicles: (vehicles) =>
        set({
            isLoading: false,
            recentlyViewedVehicles: vehicles,
            experience: vehicles.length === 0 ? HomePageExperience.FirstTimeVisitor : HomePageExperience.ReturnVisitor,
        }),
    removeRecentlyViewedVehicle: (stockNumber) => {
        const { recentlyViewedVehicles, setRecentlyViewedVehicles } = get();
        const updatedVehicles = recentlyViewedVehicles.filter((vehicle) => vehicle.stockNumber !== stockNumber);
        setRecentlyViewedVehicles(updatedVehicles);
    },
    getRecentlyViewedVehiclesData: async () => {
        const { setRecentlyViewedVehicles } = get();
        setRecentlyViewedVehicles(await getVehiclesForRecentlyViewedTiles());
    },
});

export default createRecentlyViewedVehiclesSlice;
